import React, { useEffect, useState } from 'react'
import './viewAudit.css'
import CloseIcon from '@mui/icons-material/Close';
import { AgGridReact } from 'ag-grid-react';
import { ColDef } from 'ag-grid-community';
import "ag-grid-community/styles/ag-grid.css";
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { auditCustomer } from '../../api.service/user.service';

interface ViewAuditProps {
    data?: any
}

const ViewAudit = (props: ViewAuditProps) => {

    const [rowData, setRowData] = useState<any[]>([])

    useEffect(() => {
        fetchAudit(props.data)
    }, [props.data])

    const fetchAudit = (data: any) => {
        auditCustomer(data).then((result: any) => {
            if (result.data.status) {
                console.log(result.data.claims, "claimssssssssssssssssssssssssssssss")
                const sortedData = result.data.claims.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
                console.log(sortedData, "sortedDatasortedDatasortedDatasortedData")
                setRowData(sortedData)
            }
        })

    }

    console.log(rowData)

    const colDef: ColDef[] = [
        {
            headerName: 'Role',
            field: 'role',
            flex: 1
        },
        {
            headerName: 'App ID',
            field: 'app_id',
            flex: 1
        },
        {
            headerName: 'Action Type',
            field: 'access_type',
            flex: 1
        },
        {
            headerName: 'Date/Time Stamp',
            field: 'created_at',
            flex: 1,
            cellRenderer: (params: any) => {
                const dateTime = convertDateTime(params.data.created_at)
                return (
                    <div>{`${dateTime.formattedDate} ${dateTime.formattedTime}`}</div>
                )
            }
        },
        {
            headerName: 'Approval',
            field: 'approved',
            cellRenderer: (params: any) => {
                return (
                    <div>{params.data.approved ? 'True' : 'False'}</div>
                )
            }
        }
    ]

    const convertDateTime = (date: any) => {
        const updateDate = new Date(date);
        console.log(updateDate, "Update Date")
        // Extract date and time
        const day = String(updateDate.getDate()).padStart(2, '0'); // Add leading zero if necessary
        const month = String(updateDate.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
        const year = updateDate.getFullYear();// e.g., "9/17/2024"
        const formattedDate = `${day}-${month}-${year}`;
        const formattedTime = updateDate.toLocaleTimeString(); // e.g., "3:20:20 PM"
        console.log(formattedDate, 'Formated date')
        console.log(formattedTime, 'Formated Time')
        const dateTime = {
            formattedDate,
            formattedTime
        }
        return dateTime
    }

    console.log(rowData, "Row Dataaaaaaaaaaaaaaa")


    return (

        <div className='container-100'>
            <AgGridReact
                className="ag-theme-alpine"
                rowData={rowData}
                columnDefs={colDef}
                rowHeight={40}
                headerHeight={40}
                suppressDragLeaveHidesColumns={true}
            />
        </div>

    )
}

export default ViewAudit